import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const CONTACT_EMAIL = "level@failblossom.lifestyle";

function renderText(text) {
  return text.split(CONTACT_EMAIL).map((part, index, parts) => (
    <React.Fragment key={`${part}-${index}`}>
      {part}
      {index < parts.length - 1 && (
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      )}
    </React.Fragment>
  ));
}

function PolicyPage({ policy }) {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="privacy legal-page">
      <div className="min-h-80vh px-4 lg-px-27px 2xl-px-89px">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
          <div className="breadcrumbs">
            <Link onClick={toTop} to="/">Home</Link>
            <span className="px-2">/</span>
            <Link onClick={toTop} to="/policies">Policies</Link>
            <span className="px-2">/</span>
            <span>{policy.title}</span>
          </div>
        </div>

        <article className="cms-root_cmsFullWidth-5e3 cms-root-63a px-4">
          <div className="richContent-root-63a">
            <div className="row-contained-645 row-root-63a row-contained-inner">
              <div className="text-root-63a">
                <h1>{policy.title}</h1>
                {policy.summary && <p className="policy-summary">{renderText(policy.summary)}</p>}
                {policy.note && <p className="policy-note">{renderText(policy.note)}</p>}

                {policy.sections.length > 3 && (
                  <nav className="policy-toc" aria-label={`${policy.title} contents`}>
                    <h2>On this page</h2>
                    <ul>
                      {policy.sections.map((section) => (
                        <li key={section.id}>
                          <a href={`#${section.id}`}>{section.title}</a>
                        </li>
                      ))}
                    </ul>
                  </nav>
                )}

                {policy.sections.map((section) => (
                  <section id={section.id} key={section.id}>
                    <h2>{section.title}</h2>
                    {section.paragraphs?.map((paragraph, index) => (
                      <p className="p1" key={`${section.id}-p-${index}`}>
                        {renderText(paragraph)}
                      </p>
                    ))}
                    {section.bullets && (
                      <ul className="policy-list">
                        {section.bullets.map((item, index) => (
                          <li key={`${section.id}-li-${index}`}>{renderText(item)}</li>
                        ))}
                      </ul>
                    )}
                  </section>
                ))}

                {policy.related?.length > 0 && (
                  <aside className="related-policies" aria-label="Related policies">
                    <h2>Related policies</h2>
                    <div>
                      {policy.related.map((item) => (
                        <Link key={item.to} to={item.to} onClick={toTop}>{item.label}</Link>
                      ))}
                    </div>
                  </aside>
                )}

                <p className="policy-updated"><strong>Last updated: 16 October 2026</strong></p>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
}

export default PolicyPage;
